<template>
  <div id="concreteMakeMixContract" v-loading="loading">
    <div class="buttons" v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLconcretMakeMixContent"
      id="HTMLconcretMakeMixContent"
      :class="printClass"
      :key="printClass"
    >
      <div class="HTMLconcreteMakeMixContract1">
        <!-- <p
          style="
            margin-top: 10px;
            margin-bottom: 10px;
            margin-left: 29px;
            text-align: center;
            line-height: 150%;
            text-align: right;
          "
        >
          <span style="font-family: 宋体; line-height: 150%; font-size: 16px"
            >合同编号：
            <span
              style="
                outline: 0;
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber1"
            >
              {{
                detailForm.serialNumber1
                  ? detailForm.serialNumber1
                  : detailForm.serialNumber
              }}</span
            ></span
          >
        </p> -->
        <!-- <p
          style="
            margin-top: 10px;
            margin-bottom: 10px;
            margin-left: 29px;
            text-align: center;
            line-height: 150%;
          "
        >
          <span style="font-family: 宋体; line-height: 150%; font-size: 29px"
            >&nbsp;</span
          >
        </p> -->
        <p
          style="
            margin-top: 10px;
            margin-bottom: 10px;
            margin-left: 29px;
            text-align: center;
            line-height: 150%;
          "
        >
          <span style="font-family: 宋体; line-height: 150%; font-size: 29px"
            >&nbsp;</span
          >
        </p>
        <p style="text-align: center">
          <strong
            ><span
              style="font-family: &#39;锐字云字库小标宋体1.0&#39;;letter-spacing: 2px;font-size: 35px"
              >水泥混凝土拌合加工合同</span
            ></strong
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">&nbsp;</span>
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber"
              >{{ detailForm.serialNumber || "QDLQ-" }}</span
            >
          </span>
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signDate"
              >{{ detailForm.signDate ? detailForm.signDate : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace"
              >{{ detailForm.signPlace || "青岛市" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >甲方：&nbsp;&nbsp;<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyA"
              >{{ detailForm.partyA || "青岛路桥建设集团有限公司" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >乙方：&nbsp;
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyB"
              >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
            ></span
          >
        </p>
        <h3
          style="
            text-indent: 32px;
            line-height: 31px;
            font-family: 宋体;
            font-size: 16px;
          "
        >
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，双方就甲方
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 4cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="project"
                >{{ detailForm.project || "" }}</span
              >工程<span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 6cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="projectName"
                >{{ detailForm.projectName || "" }}</span
              >水泥混凝土拌合加工</span
            ></strong
          ><strong
            ><span style="font-family: 宋体; font-size: 16px"
              >的事项协商一致，根据本工程的具体情况，订立以下合同条款：</span
            ></strong
          >
        </h3>
        <p style="margin-left: 57px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第一条</span>
              <span style="font-family: 宋体">名称、型号及配套设备</span></span
            ></strong
          >
        </p>
        <table
          ref="concretMakeTable"
          width="100%"
          :key="tableKey"
          style="border-collapse: collapse; border-width: 1px"
        >
          <thead style="display: table-header-group">
            <tr style="height: 35px" class="firstRow">
              <td
                width="47"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px">序号</span>
                </p>
              </td>
              <td
                width="128"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px"
                    >&nbsp;<span style="font-family: 宋体">名称</span></span
                  >
                </p>
              </td>
              <td
                width="79"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px">型号</span>
                </p>
              </td>
              <td
                width="56"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px">单位</span>
                </p>
              </td>
              <td
                width="56"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px">数量</span>
                </p>
              </td>
              <td
                width="169"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px">配套</span>
                </p>
              </td>
              <td
                width="57"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 宋体; font-size: 16px">备注</span>
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 28px; page-break-inside: avoid"
              v-for="item in concretMakeTableList"
              :key="item.id"
            >
              <td
                width="47"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column0 }}
              </td>
              <td
                width="128"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="79"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="56"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="56"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="169"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="57"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column6 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >注：拌合机设置地点为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 6cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhjSignPlace"
              >{{ detailForm.bhjSignPlace || "" }}</span
            ></span
          ><span style="font-family: 宋体; font-size: 16px"
            >，混凝土运输车辆的实际配备数量以甲方施工现场的实际要求为准，乙方必须保证满足甲方施工使用。</span
          >
        </p>
        <p style="margin-left: 53px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第二条</span>
              <span style="font-family: 宋体">合同期限：</span></span
            ></strong
          ><span style="font-family: 宋体; font-size: 16px"
            >自本工程开工起至本工程完工时结束。</span
          >
        </p>
        <p style="margin-left: 53px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第三条</span>
              <span style="font-family: 宋体"
                >混凝土拌合加工单价、地点、及数量</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >3.1混凝土拌合加工</span
          ><span style="font-family: 宋体; font-size: 16px"
            >裸税单价为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhjgdj"
              >{{ detailForm.bhjgdj || "" }}</span
            >元</span
          ><span style="font-family: 宋体; font-size: 16px"
            >/方，含税单价为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="hsdj"
              >{{ detailForm.hsdj || "" }}</span
            >元/方，税率<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhjgretio"
              >{{ detailForm.bhjgretio || "" }}</span
            >%，此单价包含乙方混凝土拌合机基础临建费用（含人、材、机等所有费用）、混凝土拌合机设备使用及折旧费（含设备进出场及安装拆除费）、装载机上料费和洒水车降尘费及后勤保障车费（含驾驶员工资、燃油等）、人工费（含食宿）、
            租地费用、水电费（包括混凝土加工及生活用）等与拌合生产混凝土相关的配套辅助设备、设施、管理、协调、安全生产、利润、税金等所有费用以及为拌合生产混凝土所进行的设备维修、试验调试
            机械等辅助工作费用，并且此单价为固定单价，在合同履行期间不做任何调整，如乙方单方面变更价格，属乙方违约，甲方有权终止合同，并拒付所欠乙方混凝土拌合加工款，同时乙方承担给甲方造成全部的损失。
          </span>
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >3.2不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >3.3混凝土拌合加工数量由甲方根据工程实际需用数量安排确定，结算数量以甲方施工现场实际签收的数量，并以项目部制定的确认单数量为准。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">3.4</span
          ><span style="font-family: 宋体; font-size: 16px"
            >混凝土运输地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 9cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="addPrice"
              >{{ detailForm.addPrice || "" }}</span
            >。</span
          >
        </p>
        <p style="text-indent: 40px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第四条</span>
              <span style="font-family: 宋体">结算方式与付款</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >4.1混凝土数量结算以方为单位，结算数量以甲方施工现场</span
          ><span style="font-family: 宋体; font-size: 16px">人员</span
          ><span style="font-family: 宋体; font-size: 16px">实际签收的数量</span
          ><span style="font-family: 宋体; font-size: 16px">，</span
          ><span style="font-family: 宋体; font-size: 16px"
            >并以项目部制定的确认单数量</span
          ><span style="font-family: 宋体; font-size: 16px">为准。</span>
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">4.2</span
          ><span style="font-family: 宋体; font-size: 16px">付款方式</span
          ><span style="font-family: 宋体; font-size: 16px">：</span
          ><span style="font-family: 宋体; font-size: 16px"
            >根据项目计量资金到账情况进行支付；</span
          ><span style="font-family: 宋体; font-size: 16px">采购人</span
          ><span style="font-family: 宋体; font-size: 16px"
            >以银行转帐、部分银行承兑汇票或商业承兑汇票的方式支付，</span
          ><span style="font-family: 宋体; font-size: 16px">采购人</span
          ><span style="font-family: 宋体; font-size: 16px"
            >不支付承兑贴现费用。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >乙方必须指派专人到甲方收款,收款前必须向甲方出具符合国家税务规定的等额税率为
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="deretio"
              >{{ detailForm.deretio }}</span
            >%的发票，若未开具发票则甲方不予付款或付扣除税金后的金额；已开具发票的，出具符合财务规定的收据，并在第一次收取款项时，必须持与本合同乙方单位名称一致的授权收款委托书交甲方财务备案；如被授权收款人有变动，则由乙方单位重新开具授权收款委托书交甲方财务备案，否则，甲方不予付款。</span
          >
        </p>
        <p style="text-indent: 40px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第五条</span>
              <span style="font-family: 宋体">混凝土拌合加工要求</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >5.1在甲方制定的施工生产计划时段内，乙方按照甲方提供的试验配比、技术要求、生产计划，为甲方拌和生产合格的混凝土拌合料。总体计划在
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqYear"
              >{{ detailForm.kgrqYear }}</span
            >年<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqMonth"
              >{{ detailForm.kgrqMonth }} </span
            >月<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                text-align: center;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqDay"
              >{{ detailForm.kgrqDay }}</span
            >日以前完成设备调试、试验配比、试拌等准备工作，达到正常拌和生产要求。合同履行期间，为保证甲方工程质量和工期，乙方不得利用本合同约定地点的拌合机承揽其它拌合加工任务，否则乙方自行承担由此给甲方造成的一切经济损失。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >5.2在甲方制定的施工生产计划时段内，乙方按照甲方的生产计划及要求，高效合理组织车辆为甲方运输混凝土拌合料。</span
          >
        </p>
        <p style="text-indent: 40px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第六条</span>
              <span style="font-family: 宋体">双方责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">6.1 甲方责任</span>
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.1.1甲方负责及时提供水泥、矿渣粉、粉煤灰、砂石料、外加剂，</span
          ><strong
            ><span style="font-family: 宋体; font-size: 16px"
              >&nbsp;</span
            ></strong
          ><span style="font-family: 宋体; font-size: 16px"
            >原材料的主体和品种、质量由甲方负责，乙方</span
          ><span style="font-family: 宋体; font-size: 16px"
            >严格按照甲方出具的配合比要求提供拌和服务，</span
          ><span style="font-family: 宋体; font-size: 16px"
            >不得以任何理由擅自更换原材料。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">6.1.</span
          ><span style="font-family: 宋体; font-size: 16px">2</span
          ><span style="font-family: 宋体; font-size: 16px"
            >甲方负责按照合同条款为乙方支付拌合加工费用。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">6.2 乙方责任</span>
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.1乙方必须保证混凝土拌和机、装载机及洒水车等相关辅助设备设施状况良好，数量合理，以及按照甲方要求，满足甲方工程施工使用。为保证混凝土拌和机正常生产所需的相关配套配件、材料等均由乙方自己负责并承担费用。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.2乙方须设混凝土拌合站现场管理经理（姓名：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gljlAname"
              >{{ detailForm.gljlAname || "" }}</span
            >联系电话:<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 3cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gljlAphone"
              >{{ detailForm.gljlAphone || "" }}</span
            >）在生产过程中必须服从甲方的管理指导，按照甲方提供的配合比和要求的质量、数量、时间进行生产。乙方操作人员应严格按照技术要求认真操作，保证混凝土拌合料的质量，生产过程中必须服从甲方的计划要求，根据工程需要安排昼夜生产。若因乙方原因影响甲方施工计划造成的经济损失由乙方承担。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.3乙方对所拌合加工的混凝土质量、规格、要求和标准均是乙方应该做到的和应尽的义务，同样也是乙方向甲方的承诺，无条件的遵守。无条件的服从和执行甲方、业主、监理公司所提出的混凝土质量、规格等缺陷</span
          ><span style="font-family: 宋体; font-size: 16px">整改措施</span
          ><span style="font-family: 宋体; font-size: 16px"
            >，并做到对方满意。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.4乙方负责当地政府及民众的关系协调，例如土地性质问题、综合执法部门的要求及环保措施影响正常生产范围内的事项等，费用由乙方承担。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.5乙方负责混凝土拌和机水泥、粉煤灰、矿粉、外加剂、骨料及水的电子秤设备的</span
          ><span style="font-family: 宋体; font-size: 16px">精度准确</span
          ><span style="font-family: 宋体; font-size: 16px">。</span>
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.6
            乙方负责混凝土拌和机及相关配套设备的操作、维修、保养，配备的操作、维修人员及生产工人必须保证甲方连续生产的要求，同时正常生产过程中乙方设备出现故障后维修时间不得超过24小时</span
          ><span style="font-family: 宋体; font-size: 16px">，</span
          ><span style="font-family: 宋体; font-size: 16px"
            ><span style="font-family: 宋体">每个月设备完好率不低于</span
            ><span style="font-family: 宋体">90%</span></span
          ><span style="font-family: 宋体; font-size: 16px"
            ><span style="font-family: 宋体">。</span>
          </span>
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >6.2.7乙方承担混凝土拌和生产过程中所产生的粉尘及其它污染所发生的费用。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第七条</span>
              <span style="font-family: 宋体"
                >劳务用工及工资支付管理</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >7.1
            乙方必须遵守国家法律、行政法规和政策的规定，及时办理和完善劳动用工、社会保险等手续，合法使用员工，保护员工合法权益，不得拖欠或克扣员工、（农）民工工资。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >7.2
            乙方未能及时支付其员工或（农）民工工资时，乙方同意：若乙方就所劳务工程拖欠农民工工资，出现上访现象，甲方有权从乙方混凝土加工款中扣除相应金额发放乙方所欠农民工工资，并且乙方应向甲方支付等额违约金。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >7.3
            甲方有权对乙方的员工工资支付等情况进行监督、检查，乙方不得以任何理由拒绝，并应为甲方的监督、检查提供便利。若乙方违反国家法律、行政法规及有关国家政策，拖欠或克扣员工工资，经甲方催告后在合理时间仍不纠正的，甲方将有权暂停支付混凝土加工款或单方面解除合同，由此造成的一切损失和责任由乙方承担。</span
          >
        </p>
        <p style="text-indent: 31px; line-height: 37px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第八条</span>
              <span style="font-family: 宋体"
                >安全环保施工、检查、防护</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 31px; line-height: 37px">
          <span style="font-family: 宋体; font-size: 16px"
            >8.1 乙方混凝土拌合机施工须持有合法有效的</span
          ><span style="font-family: 宋体; font-size: 16px"
            >《安全生产许可证》</span
          ><span style="font-family: 宋体; font-size: 16px"
            >及符合环保部门规定的环评手续，并严格遵守《中华人民共和国安全生产法》、国务院《建设工程安全生产条例》、《中华人民共和国环境保护法》等法律法规的规定，乙方混凝土拌合机及配套设备设施必须符合国家和有关部门的安全、环保管理规定并按安全、环保等相关部门的要求对混凝土拌合机及配套设备加装相关安全、环保措施，保证甲方工程施工的顺利进行；加强混凝土拌合机操作人员与机械的施工安全管理，对施工现场的防台</span
          ><span style="font-family: 宋体; font-size: 16px">风</span
          ><span style="font-family: 宋体; font-size: 16px"
            >、防火、防爆、防汛和防盗等采取严格的安全环保的防护措施，严格遵照甲方现场的一切安全环保的管理规定，保证施工现场安全、环保、文明施工。严格遵守国家相关临时用电规范的要求，强制采用三相五线的用电要求，并承担由于管理不力或技术措施不到位造成的事故责任和由此发生的费用；严格按安全环保标准进行施工，随时接受行业安全环保检查人员依法实施的监督检查，采取必要的安全环保防护措施，消除事故及环境污染隐患。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >8.2
            乙方在动力设备、输电线路、地下管道、密封防震车间、易燃易爆地段以及临街交通要道附近施工时，施工开始前应向甲方提出安全环保防护措施或《安全环保施工专项方案》，经甲方认可后实施，安全环保防护措施费用已包含在乙方混凝土加工单价中，不再另计。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第九条</span>
              <span style="font-family: 宋体">违约责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >9.1合同履行期间，甲乙双方应按照合同规定条款履行各自职责。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >9.2乙方应高效合理组织生产，如因设备原因、操作失误造成的废料，由乙方承担责任并赔偿甲方的损失。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >9.3乙方要积极按时完成甲方的生产计划，如因设备或乙方人员的原因未完成甲方生产要求，导致工期拖延，乙方承担责任及给甲方造成的损失。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">9.4</span
          ><span style="font-family: 宋体; font-size: 16px"
            >合同双方均不得采用虚假记录、虚假计量或其他方法在混凝土加工数量上弄虚作假。否则，除虚假部分的加工数量不得做为加工费计算依据外，还须得按虚假部分加工数量的加工费的十倍计算违约方应予承担的违约金。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >9.5合同签订前，乙方向甲方提供一套完整的供方企业资质，若乙方企业不具备承担本合同所明确的生产、经营资质，或合同签订后发现该企业已被工程所在地政府建管部门取消和限制在当地生产、经营等违法、违规现象，乙方承担全部的行政和法律后果，若给甲方造成损失的，应承担相应的损害赔偿责任。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >9.6乙方单位若发生企业变更、注册地址以及通信地址变更，必须向甲方提供企业变更后的相关材料，否则，甲乙双方发生纠纷，由乙方承担全部法律责任。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >9.7其他因乙方原因给甲方造成的一切损失，均由乙方承担。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第十条</span>
              <span style="font-family: 宋体">合同争议的解决方式：</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >本合同的解释和执行适用中华人民共和国法律。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            ><span style="font-family: 宋体"
              >本合同在履行过程中发生的争议，由双方当事人坦诚友好协商解决；也可由甲方当地工商行政管理部门调解</span
            ><span style="font-family: 宋体"
              >,
              如果协商或者调解不能解决，应向签约地点所在地法院提起诉讼。因解决争议所产生的律师费、鉴定费等其他费用由</span
            ></span
          ><span style="font-family: 宋体; font-size: 16px">乙</span
          ><span style="font-family: 宋体; font-size: 16px">方承担。</span>
        </p>
        <p style="margin-left: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第十一条</span>
              <span style="font-family: 宋体">本合同解除的条件：</span></span
            ></strong
          ><span style="font-family: 宋体; font-size: 16px">按《</span
          ><span style="font-family: 宋体; font-size: 16px"
            >中华人民共和国民法典</span
          ><span style="font-family: 宋体; font-size: 16px"
            >》有关条款执行。</span
          >
        </p>
        <p style="text-indent: 27px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              >第十二条</span
            ></strong
          ><span style="font-family: 宋体; font-size: 16px"
            >&nbsp;<span style="font-family: 宋体"
              >本合同经甲乙双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效。</span
            >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第十三条</span>
              <span style="font-family: 宋体">合同份数：</span></span
            ></strong
          ><span style="font-family: 宋体; font-size: 16px"
            >本合同共<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractTotal"
              >{{ detailForm.contractTotal }}</span
            >份，甲方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractAnum"
              >{{ detailForm.contractAnum }}</span
            >份，乙方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractBnum"
              >{{ detailForm.contractBnum }}</span
            >份，具同等法律效力。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 宋体; font-size: 16px"
              ><span style="font-family: 宋体">第十四条</span>
              <span style="font-family: 宋体">其它约定</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >14.1乙方不服从管理或在工作中严重有损甲方单位形象的或对甲方利益造成重大损害的，甲方可对其解除合同，同时赔偿甲方的全部损失。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >14.2在正常拌合生产前拌和机的生产配合比调试、混凝土拌合料试拌工作，由乙方操作，乙方人员在甲方指导下进行，因配合比调试，试验拌合而产生的相关费用（拌合费、电费、人工费等）由乙方承担。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >14.3乙方负责混凝土拌合生产过程中的安全生产管理工作，必须为其混凝土加工、驾驶员及相关人员办理相关人身意外伤害保险并承担费用。在合同履行过程中发生的一切安全事故所造成的经济损失和应承担的责任由乙方全部承担，甲方不承担连带责任。</span
          >
        </p>
        <p style="text-indent: 36px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >14.4乙方工人和车辆驾驶员上岗前，乙方必须对工人进行安全教育或安全交底并让工人佩戴好安全防护用品（比如：安全帽、帆布手套等）后方可进入混凝土拌合机场地。进入混凝土拌合机场地后，如因乙方人员不听从现场管理人员的管理而出现安全事故，其责任由乙方全部承担，甲方不承担连带责任。</span
          >
        </p>
        <p style="margin-bottom: 0; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >14.5乙方拌和机在完成甲方工程施工生产任务后，双方对乙方拌合机所剩甲方原材料（水泥、矿渣粉、粉煤灰及外加剂等）进行盘点确认，乙方必须如数归还甲方所剩所有原材料</span
          ><span style="font-family: 宋体; font-size: 16px">。</span>
        </p>
        <p style="margin-bottom: 0; text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px"
            >14.6甲乙双方间的债权、债务，在未达成一致的前提下，均不得以任何方式转让给第三方。</span
          >
        </p>
        <p style="margin-bottom: 0; text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">14.</span
          ><span style="font-family: 宋体; font-size: 16px">7</span
          ><span style="font-family: 宋体; font-size: 16px"
            >乙方拌和机必须保持外观清洁，乙方必须要定期对其人员进行环境保护法律、法规知识教育培训。甲方根据业主要求对乙方拌和机加装信息化管理配套设施，乙方必须无条件给予配合，乙方混凝土拌和机应具备相关硬件要求。</span
          >
        </p>
        <p style="margin-bottom: 0; text-indent: 32px; line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">14.</span
          ><span style="font-family: 宋体; font-size: 16px">8</span
          ><span style="font-family: 宋体; font-size: 16px"
            ><span style="font-family: 宋体"
              >本合同未涉及的条款，双方可签订补充协议，但须经甲乙双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效</span
            ><span style="font-family: 宋体"
              >, 补充协议规定与本合同具有同等效力。 &nbsp;&nbsp;</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 宋体; font-size: 16px">&nbsp;</span>
        </p>
        <table width="100%" style="border-collapse: collapse">
          <tbody>
            <tr
              style="height: 100px; font-family: 宋体; font-size: 16px"
              class="firstRow"
            >
              <td
                width="284"
                style="
                  border-width: 0;
                  border-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p style="text-align: justify; line-height: 31px">
                  <span>甲方单位（盖章）：</span
                  ><span
                    class="partA_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 150%">
                  <span style="line-height: 150%">&nbsp;</span>
                </p>
                <p style="text-align: justify; line-height: 31px">
                  <span>法人或授权代表（签字）：</span
                  ><span
                    class="partA_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_sign }}</span
                  >
                </p>
                <p style="text-align: justify; line-height: 31px">
                  <span>联系电话：</span>
                  <span
                    class="partA_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_phone }}</span
                  >
                </p>
                <p style="text-align: justify; line-height: 31px">
                  <span>日期：</span
                  ><span
                    class="partA_date"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_date }}</span
                  >
                </p>
              </td>
              <td
                width="285"
                style="
                  border-width: 0;
                  border-left: 0;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p style="text-align: justify; line-height: 31px">
                  <span>乙方单位（盖章）：</span
                  ><span
                    class="partB_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 150%">
                  <span style="line-height: 150%">&nbsp;</span>
                </p>
                <p style="text-align: justify; line-height: 31px">
                  <span>法人或委授权代表（签字）：</span
                  ><span
                    class="partB_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_sign }}</span
                  >
                </p>
                <p style="text-align: justify; line-height: 31px">
                  <span>联系电话：</span>
                  <span
                    class="partB_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_phone }}</span
                  >
                </p>
                <p style="text-align: justify; line-height: 31px">
                  <span>日期：</span
                  ><span
                    class="partB_date"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_date }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="concretMakeMixContent"
          class="mainHtml"
          id="printconcretMakeMixContent"
        ></div>
      </div>
    </div>
    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import {mixins} from '@/page/contract/template/mixin.js';
import { addPageNum, getTableData } from "../common.js";
import { addPageNumCustom } from "../common.js";
import setWatermarkDialog from "../../commonCell/setWatermarkDialog.vue";

export default {
  name: "concreteMakeMixContract",
  components: {
    setWatermarkDialog,
  },
  mixins: [mixins],
  data() {
    return {
      concretMakeMixContent: "", //富文本编辑器内容
      watermark: [""],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      tableKey: Math.random(),
      concretMakeTableList: [
        {
          id: 1,
          column0: "1",
          column1: "混凝土拌合机",
          column2: "",
          column3: "台",
          column4: "",
          column5: "",
          column6: "",
        },
      ], //中间表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  // mounted() {
  //   if (this.subServiceContractId) {
  //     this.getsubServiceContractDetail(this.subServiceContractId);
  //   }
  //   this.concretMakeMixContent = this.$refs.HTMLconcretMakeMixContent.innerHTML;
  //   this.concretMakeMixContent = document.getElementById(
  //     "HTMLconcretMakeMixContent"
  //   ).innerHTML;
  // },
  methods: {
    addItem() {
      let len = this.concretMakeTableList.length - 2;
      let id = (this.concretMakeTableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
      };
      this.concretMakeTableList.push(item);
    },
    delItem() {
      if (this.concretMakeTableList.length > 0) this.concretMakeTableList.pop();
    },
    /**
     * 初始化全部订单表格数据,配置表格列等数据
     *
     **/
    initOrderDetailTable() {
      this.getTableData();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.concretMakeTableList)
                  this.concretMakeTableList = JSON.parse(
                    this.detailForm.concretMakeTableList
                  );
                this.concretMakeTableList.forEach((item, index) => {
                  item.id = index + 1;
                  return item;
                });
              } else {
                this.detailForm = { ...this.dialogForm };
                this.concretMakeTableList = [
                  {
                    id: 1,
                    column0: "1",
                    column1: "混凝土拌合机",
                    column2: "",
                    column3: "台",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                ];
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.getValues();
      const table = this.$refs.concretMakeTable;
      this.concretMakeTableList = getTableData(
        table,
        this.concretMakeTableList,
        7
      );
      this.detailForm.concretMakeTableList = JSON.stringify(
        this.concretMakeTableList
      );
      this.tableKey = Math.random();
      this.saveCommon('concreteMakeMixContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLconcretMakeMixContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.project =
        Id.getElementsByClassName("project")[0].innerText.trim();
      Id.getElementsByClassName("project")[0].innerHTML = this.detailForm.project;
      this.detailForm.projectName =
        Id.getElementsByClassName("projectName")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText.trim();
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;
      this.detailForm.bhjSignPlace =
        Id.getElementsByClassName("bhjSignPlace")[0].innerText.trim();
      this.detailForm.bhjgdj =
        Id.getElementsByClassName("bhjgdj")[0].innerText.trim();
      this.detailForm.hsdj =
        Id.getElementsByClassName("hsdj")[0].innerText.trim();

      this.detailForm.bhjgretio =
        Id.getElementsByClassName("bhjgretio")[0].innerText.trim();

      this.detailForm.addPrice =
        Id.getElementsByClassName("addPrice")[0].innerText.trim();
      Id.getElementsByClassName("bhjSignPlace")[0].innerHTML =
        this.detailForm.bhjSignPlace;
      Id.getElementsByClassName("bhjgdj")[0].innerHTML = this.detailForm.bhjgdj;
      Id.getElementsByClassName("hsdj")[0].innerHTML = this.detailForm.hsdj;
      Id.getElementsByClassName("bhjgretio")[0].innerHTML =
        this.detailForm.bhjgretio;

      Id.getElementsByClassName("addPrice")[0].innerHTML =
        this.detailForm.addPrice;

      this.detailForm.deretio =
        Id.getElementsByClassName("deretio")[0].innerText.trim();
      this.detailForm.kgrqYear =
        Id.getElementsByClassName("kgrqYear")[0].innerText.trim();
      this.detailForm.kgrqMonth =
        Id.getElementsByClassName("kgrqMonth")[0].innerText.trim();
      this.detailForm.kgrqDay =
        Id.getElementsByClassName("kgrqDay")[0].innerText.trim();

      this.detailForm.gljlAname =
        Id.getElementsByClassName("gljlAname")[0].innerText.trim();
      this.detailForm.gljlAphone =
        Id.getElementsByClassName("gljlAphone")[0].innerText.trim();
      this.detailForm.contractTotal =
        Id.getElementsByClassName("contractTotal")[0].innerText.trim();
      this.detailForm.contractAnum =
        Id.getElementsByClassName("contractAnum")[0].innerText.trim();
      this.detailForm.contractBnum =
        Id.getElementsByClassName("contractBnum")[0].innerText.trim();

      Id.getElementsByClassName("deretio")[0].innerHTML =
        this.detailForm.deretio;
      Id.getElementsByClassName("kgrqYear")[0].innerHTML =
        this.detailForm.kgrqYear; //拌合机地点
      Id.getElementsByClassName("kgrqMonth")[0].innerHTML =
        this.detailForm.kgrqMonth;
      Id.getElementsByClassName("kgrqDay")[0].innerHTML =
        this.detailForm.kgrqDay;

      Id.getElementsByClassName("gljlAname")[0].innerHTML =
        this.detailForm.gljlAname;
      Id.getElementsByClassName("gljlAphone")[0].innerHTML =
        this.detailForm.gljlAphone;
      Id.getElementsByClassName("contractTotal")[0].innerText =
        this.detailForm.contractTotal;
      Id.getElementsByClassName("contractAnum")[0].innerText =
        this.detailForm.contractAnum;
      Id.getElementsByClassName("contractBnum")[0].innerText =
        this.detailForm.contractBnum;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_phone =
        Id.getElementsByClassName("partA_phone")[0].innerText;
      Id.getElementsByClassName("partA_phone")[0].innerHTML =
        this.detailForm.partA_phone;
      this.detailForm.partA_date =
        Id.getElementsByClassName("partA_date")[0].innerText;
      Id.getElementsByClassName("partA_date")[0].innerHTML =
        this.detailForm.partA_date;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_phone =
        Id.getElementsByClassName("partB_phone")[0].innerText;
      Id.getElementsByClassName("partB_phone")[0].innerHTML =
        this.detailForm.partB_phone;
      this.detailForm.partB_date =
        Id.getElementsByClassName("partB_date")[0].innerText;
      Id.getElementsByClassName("partB_date")[0].innerHTML =
        this.detailForm.partB_date;
    },
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLconcretMakeMixContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id, 1, "concretMakeMixContent");
      addPageNumCustom(Id, 1, "concretMakeMixContent", parseFloat(this.inputPages)+1, this.inputHeight, this.inputPosx);

      this.$set(
        this,
        "concretMakeMixContent",
        this.$refs.HTMLconcretMakeMixContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printconcretMakeMixContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto;  margin:10mm} p{line-height: 31px} .HTMLconcreteMakeMixContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLconcretMakeMixContent {
  /* position: relative; */
  width: 20cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}
.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}

p {
  line-height: 31px;
}
</style>
